import './Prompt.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';

import PromptCreateView from './components/PromptCreateView';
import PromptList from './components/PromptList';
import { EMPTY_PROMPT_ID } from './constants';

class Prompts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'Question',
    };
  }

  componentDidMount() {
    this.props.getAllPrompts();
  }

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  pickPromptId = (tab, notConsidered = []) => {
    const tabPrompts = this.props.prompts.filter(
      (p) =>
        p.type.toLowerCase().includes(tab.toLowerCase()) &&
        !notConsidered.find((nc) => nc.id === p.id),
    );

    if (tabPrompts.length === 0) return EMPTY_PROMPT_ID;

    let pickedPrompt = tabPrompts.find((p) => p.active);
    if (pickedPrompt) return pickedPrompt.id;

    pickedPrompt = tabPrompts.reduce((previous, current) =>
      previous.createdAt > current.createdAt ? previous : current,
    );
    if (pickedPrompt) return pickedPrompt.id;
    return EMPTY_PROMPT_ID;
  };

  render() {
    return (
      <Row className="promptContainer">
        <Col md={3} className="promptListContainer">
          <div className="promptList">
            <PromptList
              prompts={this.props.prompts}
              setPromptDetail={this.props.setPromptDetail}
              loadPromptDetails={this.props.loadPromptDetails}
              setCreateMode={this.props.setCreateMode}
              activeTab={this.state.activeTab}
              setActiveTab={this.setActiveTab}
              pickPromptId={this.pickPromptId}
            />
          </div>
        </Col>
        <Col md={9} className="animated fadeIn promptDetailContainer">
          {(this.props.promptDetails?.id || this.props.createMode) && (
            <PromptCreateView
              createPrompt={this.props.createPrompt}
              editPrompt={this.props.editPrompt}
              promptDetails={this.props.promptDetails}
              createMode={this.props.createMode}
              deletePrompt={this.props.deletePrompt}
              activePrompt={this.props.activePrompt}
              activeTab={this.state.activeTab}
              pickPromptId={this.pickPromptId}
              setPromptDetail={this.props.setPromptDetail}
              loadPromptDetails={this.props.loadPromptDetails}
            />
          )}
        </Col>
      </Row>
    );
  }
}

export default Prompts;
